export default __webpack_public_path__ + "static/img-art-pandas-profiling-5-035118c516d6a9bdfe44e9be1ad5951a.png";